// const mergeComparisonMap = new Map<object, Set<string>>();
/**
 * Stores a Class type, and the property Id property. If multiple properties have the Id
 * decorator, and error will be raised on startup ???
 */
const storeIdMap = new Map<object, string>();

//
/**
 * for each `target` (Class object), add to a Set of `keys` (Class property name)
 * @param target    The class, used as the Map Key
 * @param key       The property of the class object. Value will be read later when
 *                  determining the property to use as the Store Id
 */
const storeId = (target: object, key: string) => {
  // console.log("Target = " + target + " / Key = " + key);
  // get id property, if exists
  const storeIdProperty: string | undefined = storeIdMap.get(target);

  // add entry if doesn't exist. should this throw an error if it already exists ?
  if (!storeIdProperty) {
    storeIdMap.set(target, key);
  }
};

/**
 *
 * @param target    Instance of a class object. The class __proto__ property is used to
 *                  look up the Store Id property
 * @returns the property to use as a StoreId
 */
const getStoreIdProperty = (target: object): string => {
  // console.log('Target = ' + target + ' getting properties from target');
  const storeIdProperty: string | undefined = storeIdMap.get(
    //@ts-expect-error
    target.__proto__,
  );

  if (!storeIdProperty)
    //@ts-expect-error
    throw new Error(`${target.__proto__} does not have a Store ID property`);
  return storeIdProperty;
};

export { storeId as StoreId, getStoreIdProperty };
